import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { DeviceInterface, DevicesClassInterface } from '../interfaces/device.interface';

@Injectable()
export class DevicesService {
  private readonly url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.DEVICES_API_URL}`;
  }

  getDevices(query: any): Observable<DevicesClassInterface[]> {
    const queryParams = new HttpParams().set('filter', JSON.stringify(query));
    console.log(query);
    console.log(queryParams);
    return this.http.get<DevicesClassInterface[]>(this.url, { params: queryParams });
  }

  createDevice(device: DeviceInterface): Observable<DeviceInterface> {
    return this.http.post<DeviceInterface>(this.url, device);
  }

  updateDevice(device: DeviceInterface): Observable<DeviceInterface> {
    return this.http.put<DeviceInterface>(`${this.url}/${device.id}`, device);
  }

  deleteDevice(deviceClass: DeviceInterface): Observable<DevicesClassInterface> {
    return this.http.delete<DevicesClassInterface>(`${this.url}/${deviceClass.id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/devices.service.ts